export default __webpack_public_path__ + "images/0ca7b680e09badb7a203a2e8d9d16f80.svg";